var map = {
	"./BE_Logo_OVB_Willemot_Blue_cmyk.svg": 171,
	"./BE_Logo_OVB_Willemot_White.svg": 354,
	"./Ryan-Taylor-Green-Tick.svg": 527,
	"./a-edit_1x_blue.svg": 355,
	"./a-jump-ovbblue.svg": 529,
	"./a-open_with-green.svg": 955,
	"./a-trash_1x_ovbBlue.svg": 79,
	"./autorenew.svg": 532,
	"./autorenew_white.svg": 959,
	"./baseline-direct-Sign24px-green.svg": 960,
	"./baseline-reply-24px-green.svg": 961,
	"./baseline-reply-to-willemot-24px-green.svg": 962,
	"./baseline-send-reminder-24px-green.svg": 963,
	"./corner.svg": 534,
	"./create-24px.svg": 974,
	"./ic_delete_forever_black_24px.svg": 977,
	"./ic_do_not_disturb_black_24px.svg": 261,
	"./ic_done_gray_32px.svg": 978,
	"./ic_done_green_32px.svg": 979,
	"./ic_done_white_32px.svg": 980,
	"./icn-agenda.svg": 535,
	"./icn-automotive.svg": 536,
	"./icn-b2b.svg": 537,
	"./icn-claimWizard-white.svg": 356,
	"./icn-claims.svg": 538,
	"./icn-clients.svg": 539,
	"./icn-contracts.svg": 540,
	"./icn-credit.svg": 541,
	"./icn-dsdocuments-blue.svg": 542,
	"./icn-dsdocuments-green.svg": 543,
	"./icn-dsdocuments-white.svg": 357,
	"./icn-dsdocuments.svg": 544,
	"./icn-family.svg": 545,
	"./icn-faq.svg": 546,
	"./icn-fire.svg": 547,
	"./icn-generali.svg": 548,
	"./icn-health.svg": 549,
	"./icn-home.svg": 550,
	"./icn-inbox-blue.svg": 551,
	"./icn-inbox-white.svg": 358,
	"./icn-inbox.svg": 552,
	"./icn-info.svg": 553,
	"./icn-life.svg": 554,
	"./icn-link_1x_blue.svg": 555,
	"./icn-links.svg": 556,
	"./icn-logout.svg": 557,
	"./icn-misc.svg": 558,
	"./icn-news.svg": 559,
	"./icn-no-result.svg": 23,
	"./icn-office.svg": 560,
	"./icn-outbox.svg": 561,
	"./icn-outline-location_on-24px.svg": 562,
	"./icn-production.svg": 563,
	"./icn-tasklist.svg": 564,
	"./icn-transport.svg": 565,
	"./icn-webapps.svg": 566,
	"./icn-willdoc.svg": 567,
	"./icn-workinjuries.svg": 568,
	"./icon-cancel.svg": 569,
	"./m-agenda.svg": 570,
	"./m-b2b.svg": 571,
	"./m-claims.svg": 572,
	"./m-clients.svg": 573,
	"./m-dsdocuments.svg": 574,
	"./m-faq.svg": 575,
	"./m-generali.svg": 576,
	"./m-inbox-blue.svg": 577,
	"./m-inbox.svg": 578,
	"./m-links.svg": 579,
	"./m-logout.svg": 359,
	"./m-news.svg": 580,
	"./m-office.svg": 581,
	"./m-outbox.svg": 582,
	"./m-production.svg": 583,
	"./m-tasklist.svg": 584,
	"./m-webapps.svg": 585,
	"./m-willdoc.svg": 586,
	"./notification-bell.svg": 1000,
	"./person_search_green.svg": 588,
	"./print-black-18dp.svg": 360,
	"./print-white-18dp.svg": 1007,
	"./recycle.svg": 1009
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 591;



//////////////////
// WEBPACK FOOTER
// ./resources/images ^\.\/.*\.svg$
// module id = 591
// module chunks = 0